import React from "react";
import { Navigate } from "react-router-dom";
import FinanceNoAccess from "../components/Finance/FinanceNoAccess";

/**
 * Route/page guard for finance screens (group permissions via permissionStorage).
 */
export default function FinanceRoute({ when, children, redirect }) {
  const allowed = typeof when === "function" ? when() : Boolean(when);
  if (!allowed) {
    if (redirect) {
      return <Navigate to={redirect} replace />;
    }
    return <FinanceNoAccess />;
  }
  return children;
}
